import { Contrast } from "../../../types/general.types";
import { hexToRgba } from "@icarros/utils-react";
import styled, { css } from "styled-components";
import { ids } from "@icarros/theme-react";
import Icon from "../../Images/Icon/Icon";
const { size, color, opacity } = ids || {};
const defaultStyle = css `
  background: ${(props) => props.onHover
    ? hexToRgba(color.action.secondary.ids_color_action_secondary_variant, opacity.ids_opacity_soft)
    : hexToRgba(color.action.secondary.ids_color_action_secondary_base, opacity.ids_opacity_empty)};
  border-color: ${(props) => props.onHover
    ? color.action.secondary.ids_color_action_secondary_variant
    : color.action.secondary.ids_color_action_secondary_base};
`;
const activeDefaultStyle = css `
  background: ${(props) => props.onHover
    ? color.action.secondary.ids_color_action_secondary_variant
    : color.action.secondary.ids_color_action_secondary_base};
  border-color: ${color.action.secondary.ids_color_action_secondary_variant};
`;
const defaultDisabled = css `
  background: ${hexToRgba(color.action.disabled.ids_color_action_disabled_base, opacity.ids_opacity_empty)};
  color: ${color.action.disabled.ids_color_action_disabled_variant};
  border-color: ${color.action.disabled.ids_color_action_disabled_base};
`;
const defaultOnDark = css `
  background: ${(props) => props.onHover
    ? hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_soft)
    : hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_empty)};
  border-color: ${color.contrast.ids_color_contrast_onDark};
`;
const activeOnDark = css `
  background: ${(props) => props.onHover
    ? hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_strong)
    : color.contrast.ids_color_contrast_onDark};
  border-color: ${color.contrast.ids_color_contrast_onDark};
`;
const onDarkDisabled = css `
  background: ${hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_empty)};
  border-color: ${hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_medium)};
`;
const defaultOnLight = css `
  background: ${(props) => props.onHover
    ? hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_soft)
    : hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_empty)};
  border-color: ${color.contrast.ids_color_contrast_onLight};
`;
const activeOnLight = css `
  background: ${(props) => props.onHover
    ? hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_strong)
    : color.contrast.ids_color_contrast_onLight};
  border-color: ${color.contrast.ids_color_contrast_onLight};
`;
const onLightDisabled = css `
  background: ${hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_empty)};
  border-color: ${hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_medium)};
`;
const getButtonKindStyle = (isDisabled, contrast, checked) => {
    if (contrast === Contrast.dark) {
        if (isDisabled)
            return onDarkDisabled;
        return checked ? activeOnDark : defaultOnDark;
    }
    if (contrast === Contrast.light) {
        if (isDisabled)
            onLightDisabled;
        return checked ? activeOnLight : defaultOnLight;
    }
    if (isDisabled)
        return defaultDisabled;
    return checked ? activeDefaultStyle : defaultStyle;
};
export const StyledFilterTag = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  position: relative;
  & > input {
    position: absolute;
    appearance: none;
    border: 0;
    cursor: pointer;
    height: 100%;
    width: 100%;
  }
`;
export const StyledIcon = styled(Icon) `
  z-index: 1;
  cursor: pointer;
`;
export const StyledFilterTagContent = styled.label `
  display: flex;
  align-items: center;
  border: ${size.border_width.ids_size_border_small} solid
    ${color.action.secondary.ids_color_action_secondary_base};
  border-radius: ${size.corner_radius.ids_size_cornerRadius_tags_02};
  color: ${color.action.secondary.ids_color_action_secondary_base};
  gap: ${size.general.ids_size_general_8x};
  height: 100%;
  padding: ${size.general.ids_size_general_6x}
    ${size.general.ids_size_general_16x};
  transition: background-color 200ms linear;
  user-select: none;
  white-space: nowrap;
  ${({ isDisabled, contrast, checked }) => getButtonKindStyle(isDisabled, contrast, checked)}
`;
//# sourceMappingURL=FilterTag.style.js.map